import backGroundImage from '../../assets/images/bg.jpeg'

export const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'white'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    height: '100vh',
    backgroundImage: `url(${backGroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center'
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  logo: {
    height: '25vh',
    marginTop: '3vh',
    marginBottom: '12vh'
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    bottom: 28
  },
  button: {
    margin: '0px 20px 20px 20px',
    width: '90vw',
    maxWidth: '500px',
    textTransform: 'none'
  },
  link: {
    textDecoration: 'none',
    color: 'white',
    alignSelf: 'center'
  },
  appleStore: {
    height: '6vh',
    paddingRight: '50px'
  },
  googlePlay: {
    height: '6vh'
  },
  appWrapper: {
    display: 'inline',
    float: 'left'
  },
  heroLogo: {
    height: '14vh',
    borderRadius: '25px',
    boxShadow: '0px 3px 45px rgb(0 0 0 / 7%)',
    marginTop: '5vh',
    marginBottom: '1.5rem'
  },
  heroLogoWrapper: {
    display: 'flex',
    alignItems: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/pages/StartPage/styles.js